import React, { Component } from 'react'
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import loadable from './commons/utils/loadable'
import intl from 'react-intl-universal'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale-provider/zh_CN'
import 'animate.css'
import './commons/style/global/base.scss'
import './commons/style/global/App.scss'
import moment from 'moment'
import 'moment/locale/zh-cn'
// import { registerMicroApps, start } from 'qiankun'

moment.locale('zh-cn')

// 公共模块
const DefaultLayout = loadable(() => import('./layout'))

// 基础页面
const Login = loadable(() => import('./pages/Login'))

const TwoPointsOneLine = loadable(() => import('@/pages/bigData/twoPointsOneLine/index')) // 两点一线大数据
const FlowDirection = loadable(() => import('@/pages/bigData/flowDirection/index')) // 流量流向
const EnterpriseScreen = loadable(() => import('@/pages/bigData/enterpriseScreen')) // 企业大屏

const currentLocale = navigator.language

class App extends Component {
  componentDidMount () {
    intl.init({
      currentLocale: currentLocale,
      locales: {
        [currentLocale]: Object.assign(require(`./locales/${currentLocale}`).default, require(`@/commons/components/locales/${currentLocale}`).default)
      }
    })
    // registerMicroApps([
    //   {
    //     // 子应用唯一名称
    //     name: 'app2',
    //     // 子应用入口
    //     entry: '//localhost:3001',
    //     // 子应用挂载的元素
    //     container: '#root',
    //     // 子应用匹配路径
    //     activeRule: '/app2'
    //   }
    // ])

    // start()
  }

  render () {
    let url
    if (window.localStorage.getItem('mark') === '1') {
      url = '/' + JSON.parse(window.localStorage.getItem('FirstMenuUri'))
    } else {
      url = '/index?id=' +
      window.localStorage.getItem('menukey') +
      '&uri=' +
      JSON.parse(window.localStorage.getItem('FirstMenuUri'))
    }
    return (
      <ConfigProvider
        locale={zhCN}
      >
        <Router>
          <Switch>
            <Route path='/' exact render={() => <Redirect to={url} />} />
            <Route path='/login' component={Login} />
            <Route path='/twopointsoneline' component={TwoPointsOneLine} />
            <Route path='/flowDirection' component={FlowDirection} />
            <Route path='/enterprisescreen' component={EnterpriseScreen} />
            <Route component={DefaultLayout} />
          </Switch>
        </Router>
      </ConfigProvider>
    )
  }
}

export default App
